import { ArrowCircleRight, Check } from "@phosphor-icons/react";
import { useState } from "react";

import {
  ManageSubscriptionDialog,
  SubscriptionPlanIcon,
} from "common/components/subscriptions";
import Alert from "common/components/ui/Alert";
import { Button } from "common/components/ui/Button";

const features = [
  "Slack onboarding",
  "Full whitelabel",
  "Team collaboration",
  "Profile migration assistance",
];

export default function GetAgencyPlan() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <div className="p-1.5 bg-whiteGray rounded-4xl">
        <div className="flex border border-black-200 rounded-4xl">
          {/*left section*/}
          <div className="flex flex-col w-96 pl-7 pr-8 pt-9 pb-8 bg-white rounded-l-4xl">
            <div className="gap-x-4 flex mb-9">
              <SubscriptionPlanIcon size="md" plan="agency" />
              <h2 className="text-xl-bold">Get started with our Agency Plan</h2>
            </div>
            <div className="flex flex-col gap-y-2">
              {features.map((feature) => (
                <div key={feature} className="flex gap-x-2 items-center">
                  <Check className="text-green-600" />
                  <span className="text-xs-medium">{feature}</span>
                </div>
              ))}
            </div>
            <svg
              width="324"
              height="2"
              viewBox="0 0 324 1"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="my-5"
            >
              <title>dashed line</title>
              <path
                d="M0 1H324"
                stroke="black"
                stroke-opacity="0.25"
                stroke-linejoin="round"
                stroke-dasharray="1 5"
              />
            </svg>
            <Alert className="mb-9">
              The Agency Plan gives you a large pool of seats that can be
              assigned to any of your workspaces that do not already have an
              active LinkedIn Seat subscription.
            </Alert>
            <div className="gap-x-2 flex ml-auto mt-9">
              <Button className="" variant="secondary-black" size="sm">
                Learn more
              </Button>
              <Button
                size="sm"
                rightIcon={<ArrowCircleRight weight="fill" />}
                onClick={() => setIsOpen(true)}
              >
                Get started
              </Button>
            </div>
          </div>
          {/*right section*/}
          <div className="flex-1 rounded-r-4xl bg-[linear-gradient(345deg,#030712_0.73%,#4515BE_34.15%,#642CFF_53.76%,#8A7AFF_90.47%)]" />
        </div>
      </div>
      <ManageSubscriptionDialog
        plan="agency"
        isOpen={isOpen}
        setIsOpen={setIsOpen}
      />
    </>
  );
}
